/**
 * Valida um código de barras EAN-13.
 * @param ean Código EAN como string (pode conter zeros à esquerda).
 * @returns booleano indicando se o código é válido.
 */
export function validateEAN13(ean: string): boolean {
    // Deve conter exatamente 13 caracteres numéricos
    if (!/^\d{13}$/.test(ean)) return false;

    // Calcula o dígito verificador
    let sum = 0;
    for (let i = 0; i < 12; i++) {
        const digit = parseInt(ean[i], 10);
        // Multiplica por 1 se for posição par, por 3 se for ímpar (começando do índice 0)
        sum += i % 2 === 0 ? digit : digit * 3;
    }
    const checkDigit = (10 - (sum % 10)) % 10;
    return checkDigit === parseInt(ean[12], 10);
}